const segmentHasNoCheckedBaggage = (segmentFare) => {
  const bags = segmentFare?.includedCheckedBags;
  return (!bags?.quantity || bags.quantity === 0) && !bags?.weight;
};

export const flightHasNoCheckedBaggage = (flight) => {
  const segments = flight?.travelerPricings?.[0]?.fareDetailsBySegment;
  if (!segments?.length) return false;

  return segments.every(segmentHasNoCheckedBaggage);
};
